import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><path id=\"a\" d=\"M0 0h24v24H0z\"></path></defs><clipPath id=\"b\"><use xlink:href=\"#a\" style=\"overflow:visible;\"></use></clipPath><g style=\"clip-path:url(#b);\"><path d=\"M0 0h24v24H0z\" style=\"fill:#1877f2;\"></path><path d=\"M23.5 12.1C23.5 5.7 18.4.6 12 .6S.5 5.7.5 12.1c0 5.7 4.2 10.5 9.7 11.4v-8H7.3v-3.3h2.9V9.5c0-2.9 1.7-4.5 4.3-4.5 1.3 0 2.6.2 2.6.2V8h-1.5c-1.4 0-1.9.9-1.9 1.8V12H17l-.5 3.3h-2.7v8c5.5-.7 9.7-5.5 9.7-11.2\" style=\"fill:#fff;\"></path></g>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }